var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1118 21.814L14.7414 26.9651C14.8791 27.1708 15.0639 27.3406 15.2804 27.4604C15.497 27.5802 15.739 27.6466 15.9864 27.654C16.2338 27.6613 16.4793 27.6095 16.7026 27.5029C16.926 27.3962 17.1206 27.2377 17.2703 27.0407L28.8895 12.3399M3.33398 20.0007C3.33398 24.4209 5.08993 28.6602 8.21554 31.7858C11.3411 34.9114 15.5804 36.6673 20.0007 36.6673C24.4209 36.6673 28.6602 34.9114 31.7858 31.7858C34.9114 28.6602 36.6673 24.4209 36.6673 20.0007C36.6673 15.5804 34.9114 11.3411 31.7858 8.21554C28.6602 5.08993 24.4209 3.33398 20.0007 3.33398C15.5804 3.33398 11.3411 5.08993 8.21554 8.21554C5.08993 11.3411 3.33398 15.5804 3.33398 20.0007Z",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSuccess);
export default __webpack_public_path__ + "static/media/done-success.8e24dbf375bd02366fe1d628197c7c9c.svg";
export { ForwardRef as ReactComponent };